import { Injectable, inject } from '@angular/core';

import { ApContentService } from '@ap/content';

import { ErrorMessages } from './error-messages.interface';

@Injectable()
export class ApErrorMessageService {
    private readonly contentService = inject(ApContentService);

    /**
     * Create ErrorMessages object from content keys.
     * Gets all error field with a matching contentPrefix, and transforms it to
     */
    public parse(contentPrefix: string): ErrorMessages {
        const keys = this.contentService.getEntriesWithKey(`${contentPrefix}.error`);
        return this.convertToMessages(keys);
    }

    /**
     * Create ErrorMessages object from content keys.
     * Gets all error field with a matching contentPrefix, and transforms it to
     */
    public parseFromContentObject(content: any, contentPrefix?: string): ErrorMessages {
        if (!content) {
            return {};
        }
        const keys = Object.keys(content).filter((key) =>
            contentPrefix ? key.startsWith(`${contentPrefix}.error`) : key.includes(`.error`)
        );
        return this.convertToMessages(keys);
    }

    /**
     * Convert array of strings to object
     */
    private convertToMessages(keys: string[]): ErrorMessages {
        const messages = {};

        keys.forEach((key) => {
            const errorKeys = key.split('.');
            const errorKey = errorKeys[errorKeys.length - 1];
            messages[errorKey] = key;
        });
        return messages;
    }
}
